import { Switch } from '@kc-console/common-ui';
import { useTranslation } from '@kc-console/core';

import type { CompactModeState } from '../../hooks/DataTable/features';

export interface ActionBarSettingsCompactModeSwitchProps {
  compactMode: CompactModeState;
  onCompactModeChange: (checked: CompactModeState) => void;
}

export default function ActionBarSettingsCompactModeSwitch(
  props: ActionBarSettingsCompactModeSwitchProps,
) {
  const { t } = useTranslation();
  const { compactMode, onCompactModeChange } = props;

  return (
    <Switch
      text={t('ui:settings.compact_mode')}
      checked={compactMode}
      onChange={(e, checked) => onCompactModeChange(checked)}
      size="md"
    />
  );
}
